import './floorplan.less'

import {Block, BlockType} from 'blocks/block'
import {Blocks} from 'blocks/blocks'
import {DemosItemType} from 'pages/demos/demos'
import {DemofloorSVG} from 'pages/floorplan/demofloorsvg'
import React, {useEffect, useState} from 'react'
import {PageData} from 'types'
import {style} from 'util/style'
import {DemosFilter} from 'views/demos/demosfilter'
import {FiltertagsItemType} from 'views/filter/filtertags'
import {Hero, HeroType} from 'views/hero/hero'
import {Layout} from 'views/layout'
import {Theme} from 'views/theme'
import {Demolegend} from './demolegend'
import {DemoPopup} from './demopopup'

const styles = style('page')

export const Floorplan: React.FC<PageData & {
	hero: HeroType
	blocks: Array<BlockType>
	demos: Array<DemosItemType>
	tags: Array<FiltertagsItemType>
}> = data => {
	const {title, hero, blocks, demos, project_key, tags} = data
	const [activeDemo, setActiveDemo] = useState<DemosItemType>(null)
	const [filters, setFilters] = useState([])
	const [highlights, setHighlights] = useState([])

	const light: boolean = project_key === 'itfbelgium' || project_key === 'itf'

	const onClick = e => {
		const demo = demos.filter(obj => {
			return obj.floorplan_id === e.currentTarget.id
		})[0]
		if (!demo) return
		setActiveDemo(demo)
	}

	const setVertical = tag => {
		if (filters && filters.includes(tag)) return
		const newFilters = [...filters, tag]
		setFilters(newFilters)
	}

	const toggleHighlight = h => {
		if (highlights && highlights.includes(h)) setHighlights([])
		else setHighlights([h])
	}

	const init = () => {
		const elements = document.querySelectorAll('[id]')
		elements.forEach(el => {
			if (
				el.id.includes('imec') ||
				el.id.includes('lounge') ||
				el.id.includes('toiletten') ||
				el.id.includes('sponsor') ||
				el.id.includes('cloakroom')
			) {
				el.classList.add('is-active')
			} else {
				el.classList.remove('is-active')
			}
		})
	}

	useEffect(() => {
		if (filters.length || activeDemo) {
			const elements = document.querySelectorAll('[id]')
			elements.forEach(el => el.classList.remove('is-active'))
		} else if (highlights.length === 0) {
			init()
		}

		demos.map(demo => {
			const element = document.getElementById(demo.floorplan_id)

			if (!element) return

			let active = false
			if (demo === activeDemo) active = true
			if (
				filters.length > 0 &&
				filters.some(f =>
					demo.demo_labels?.some(label => label.id.toString() === f)
				)
			)
				active = true
			if (highlights.includes('demo')) active = true

			element.classList.add('demofloor_area')
			// element.classList.add('is-demo')
			if (active) {
				element.classList.add('is-active')
			} else {
				element.classList.remove('is-active')
			}
			element.addEventListener('click', onClick)
		})
	}, [activeDemo, filters, demos, highlights])

	useEffect(() => {
		const elements = document.querySelectorAll('[id]')
		elements.forEach(el => el.classList.remove('is-active'))
		setFilters([])

		highlights.map(h => {
			const elements = document.querySelectorAll(`[id*=${h} i]`)

			if (!elements) return

			elements.forEach(el => el.classList.add('is-active'))
		})
	}, [highlights])

	return (
		<Layout page={data}>
			<div class={styles()}>
				<Hero pagetitle={title} {...hero} />
				<Blocks>
					{blocks.map((block, i) => (
						<Block key={i} {...block} />
					))}
				</Blocks>
				<Theme.OuterContainer>
					<Theme.Container>
						<DemosFilter
							tags={tags}
							filters={filters}
							setFilters={setFilters}
						/>
						<DemofloorSVG light={light} />
						<Demolegend
							highlights={highlights}
							mod={light ? 'light' : 'dark'}
							toggleHighlight={toggleHighlight}
						/>
						<DemoPopup
							demo={activeDemo}
							onClose={() => setActiveDemo(null)}
							setVertical={setVertical}
							theme={project_key}
							light={light}
						/>
					</Theme.Container>
				</Theme.OuterContainer>
			</div>
		</Layout>
	)
}
